import { render, staticRenderFns } from "./BarChartArrecadacao.vue?vue&type=template&id=018a11cc"
import script from "./BarChartArrecadacao.vue?vue&type=script&lang=js"
export * from "./BarChartArrecadacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports